import React, { type FC } from 'react'
import { useSelector } from 'react-redux'
import { channelSelector } from 'redux-store/channel/channel.selectors'
import { getChannelAdTargeting } from 'pages/ChannelPage/Start/getChannelAdTargeting'

import classNames from 'classnames'
import { isViewingStreamSelector } from 'redux-store/userInterface/userInterface.selectors'
import { NativeAd } from 'advertising/NativeAd/NativeAd'
import { getFormatedTextForStructuredPlainText } from 'helpers/getFormatedTextForStructuredPlainText'

import { type GameWithoutLivestream } from '../../types'

import styles from './AboutStream.module.scss'

type AboutStreamProps = {
  mediaObject: GameWithoutLivestream
}

export const AboutStream: FC<AboutStreamProps> = ({ mediaObject }) => {
  const isViewingStream = useSelector(isViewingStreamSelector)
  const description = mediaObject.description || ''
  const formatedDescription = getFormatedTextForStructuredPlainText(
    description || mediaObject.location?.name
  )
  const channelDetails = useSelector(channelSelector).data
  const { parentChannelDomain, partnerDomain, sportCategory, countryCode } =
    getChannelAdTargeting(channelDetails)

  return (
    <div
      className={classNames(styles.AboutStream, {
        [styles.IsViewingStream]: isViewingStream
      })}
    >
      <NativeAd
        slotPath="/21792873324/Viewer_About_Slot"
        adId="div-gpt-ad-1680188725142-0"
        size={['fluid']}
        targetingOptions={{
          partnerDomain: partnerDomain,
          parentChannelDomain: parentChannelDomain,
          sportCategory: sportCategory,
          countryCode: countryCode
        }}
        externalStyle={styles.NativeAd}
      />
      <div className={styles.Wrapper}>
        <div className={styles.Description}>
          <div className={styles.ContentContainer}>
            {!isViewingStream && (
              <div className={styles.Title}>{mediaObject?.title}</div>
            )}
            <div className={styles.Text}>
              {formatedDescription && formatedDescription}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
